export const regions = [
    {
        code: 'au',
        countryCode: 'AU',
        name: 'Australia',
        currency: 'AUD',
        locale: 'en-AU',
        timezone: 'Australia/Brisbane',
        taxRate: 0.1,
    },
    {
        code: 'nz',
        countryCode: 'NZ',
        name: 'New Zealand',
        currency: 'NZD',
        locale: 'en-NZ',
        timezone: 'Pacific/Auckland',
        taxRate: 0.15,
    },
];
export function getRegion(code) {
    const region = regions.find((r) => r.code === code.toLowerCase());
    if (!region) {
        throw new Error(`Unknown region "${code}". Configured regions: ${regions.map((r) => r.code).join(', ')}`);
    }
    return region;
}
/** Name of the environment variable / secret key holding the Acumatica tenant for a region. */
export function erpTenantEnvVar(region) {
    return `ERP_TENANT_${region.code.toUpperCase()}`;
}
/**
 * Each market has its own Acumatica login, not just its own tenant, so the
 * username and password are per-region like the tenant. Same convention, so
 * adding a region to this list is still the only step.
 */
export function erpUsernameEnvVar(region) {
    return `ERP_USERNAME_${region.code.toUpperCase()}`;
}
export function erpPasswordEnvVar(region) {
    return `ERP_PASSWORD_${region.code.toUpperCase()}`;
}
/** Lambda environment variable holding the credentials secret ARN for a region. */
export function erpCredentialsArnEnvVar(region) {
    return `ERP_CREDENTIALS_SECRET_ARN_${region.code.toUpperCase()}`;
}
/**
 * The admin API calls the Acumatica contract-based REST API (inventory items
 * and BOMs) with its own per-market login, never the feed-sync one: different
 * endpoint, different trust level, owned by the admin team. Same per-region
 * convention as the sync credentials above.
 */
export function erpAdminUsernameEnvVar(region) {
    return `ERP_ADMIN_USERNAME_${region.code.toUpperCase()}`;
}
export function erpAdminPasswordEnvVar(region) {
    return `ERP_ADMIN_PASSWORD_${region.code.toUpperCase()}`;
}
/** Admin Lambda environment variable holding the admin REST credentials secret ARN for a region. */
export function erpAdminCredentialsArnEnvVar(region) {
    return `ERP_ADMIN_CREDENTIALS_SECRET_ARN_${region.code.toUpperCase()}`;
}
/** S3 prefix under which synced product data for a region is stored. */
export function productDataPrefix(region) {
    return `product-data/${region.code}`;
}
//# sourceMappingURL=regions.js.map